
export default [
  {
    path: "/",
    redirect: "/ielts/listen"
  },
  {
    path: "collectionT",
    component: () => import("@/views/collection/collectionT")
  },
  {
    path: "wrongQuestion",
    component: () => import("@/views/wrongQuestion")
  },
  {
    path: "hearingVocabulary",
    component: () => import("@/views/hearingVocabulary/hearingVocabulary.vue")
  },
  {
    path: "vocabularyDetails",
    component: () => import("@/views/hearingVocabulary/vocabularyDetails/vocabularyDetails.vue")
  },
  {
    path: "/ielts/listen",
    component: () => import("@/views/ielts/listen/listen.vue")
  },
  {
    path: "/ielts/listen2",
    component: () => import("@/views/ielts/listen/listen2.vue")
  },
    {
    path: "/ielts/listen3",
    component: () => import("@/views/ielts/listen/listen3.vue")
  },
  {
    path: "/ielts/listen4",
    component: () => import("@/views/ielts/listen/listen4.vue")
  },
  {
    path: "/ielts/listen5",
    component: () => import("@/views/ielts/listen/listen5.vue")
  },
  {
    path: "read",
    component: () => import("@/views/ielts/read/read.vue")
  },
  {
    path: "read2",
    component: () => import("@/views/ielts/read/read2.vue")
  },
  {
    path: "read3",
    component: () => import("@/views/ielts/read/read3.vue")
  },
  {
    path: "read4",
    component: () => import("@/views/ielts/read/read4.vue")
  },
  {
    path: "read5",
    component: () => import("@/views/ielts/read/read5.vue")
  },
  // 雅思的听力的收藏单词的详情页面
  {
    path: "/ielts/vocabularyDetails",
    component: () =>
      import("@/views/ielts/listen/vocabularyDetails/vocabularyDetails.vue")
  },
  // 雅思的听力的收藏单词的页面
  {
    path: "/ielts/hearingVocabulary",
    component: () =>
      import("@/views/ielts/listen/hearingVocabulary/hearingVocabulary.vue")
  },
  //雅思模考总页面
  {
    path: "/ielts/mock",
    component: () => import("@/views/ielts/mock/index.vue")
  },
  //雅思写作总页面
  {
    path: "/ielts/writing",
    component: () => import("@/views/ielts/writing/index.vue")
  },
  //雅思写作答题页面
  {
    path: "/ielts/writing/writingDetils",
    component: () =>
      import("@/views/ielts/writing/writingDetils/writingDetils.vue")
  },
    //雅思写作答题页面
  {
    path: "/ielts/writing/writingDetils2",
    component: () =>
      import("@/views/ielts/writing/writingDetils2/writingDetils2.vue")
  },
  // 雅思口语剑雅真题页面
  {
    path: "/ielts/oralLanguage",
    component: () => import("@/views/ielts/oralLanguage/oralLanguage.vue")
  },
  // 雅思口语剑雅真题做题页面
  {
    path: "/ielts/oralLanguage/practice",
    component: () => import("@/views/ielts/oralLanguage/practice")
  },
  // 雅思口语最新题库
  {
    path: "/ielts/questionBank",
    component: () => import("@/views/ielts/questionBank/questionBank.vue")
  },
  // 雅思口语选择题目页面
  {
    path: "/ielts/questionBank/practiceList",
    component: () => import("@/views/ielts/questionBank/practiceList")
  },
  // 雅思口语最新题库做题页面
  {
    path: "/ielts/questionBank/practice",
    component: () => import("@/views/ielts/questionBank/practice")
  },
  //阅读解析
  {
    path: "/ielts/read/analysis",
    component: () => import("@/views/ielts/analysis/analysis")
  },
  //听力解析
  {
    path: "/ielts/tingli",
    component: () => import("@/views/ielts/analysis/tingli")
  },
  //写作解析
  {
    path: "/ielts/xiezuo",
    component: () => import("@/views/ielts/analysis/xiezuo")
  },
  //写作解析
  {
    path: "/ielts/kkk",
    component: () => import("@/views/ielts/analysis/kkk")
  },
  //智能生成故事
  {
    path: "/ielts/story",
    component: () => import("@/views/ielts/storyGenerator/storyGenerator")
  },
  //模考阅读解析
  {
    path: "/ielts/mAnalysis",
    component: () => import("@/views/ielts/modelExaminationAnalysis/mAnalysis")
  },
  //模考听力解析
  {
    path: "/ielts/mTingli",
    component: () => import("@/views/ielts/modelExaminationAnalysis/mTingli")
  },
  //模考写作解析
  {
    path: "/ielts/mPenAndInk",
    component: () => import("@/views/ielts/modelExaminationAnalysis/mPenAndInk")
  },
  //写作批改列表
  {
    path: "/ielts/xieZuoList",
    component: () => import("@/views/ielts/xieZuoList/index")
  },
  //口语批改列表
  {
    path: "/ielts/kouYuList",
    component: () => import("@/views/ielts/kouYuList/index")
  },
  //口语解析
  {
    path: "/ielts/kouyu",
    component: () => import("@/views/ielts/analysis/kouyu")
  },
  //写作示例
  {
    path: "/ielts/example",
    component: () => import("@/views/ielts/example/index")
  },
  //
  {
    path: "/ielts/ieltsCourse",
    component: () => import("@/views/ielts/ieltsCourse/index")
  },
  //新版解析 阅读解析
  {
    path: "/ielts/newAnalysis",
    component: () => import("@/views/ielts/analysis/newAnalysis")
  },
  //新版解析 听力解析
  {
    path: "/ielts/newAnalysis1",
    component: () => import("@/views/ielts/analysis/newAnalysis1")
  },
  // 写作解析
  {
    path: "/ielts/newAnalysis2",
    component: () => import("@/views/ielts/analysis/newAnalysis2")
  }
];



// WEBPACK FOOTER //
// ./src/router/children/chil_ielts.js